import styles from "./YoutubeInstructions.module.css";
import instruction from "../Icons/info.png";
import page1 from "./page1.png";
import page2 from "./Page2.png";

const YoutubeInstructions = () => {
    return (
        <div className = {styles.body}>
            <h1 className = {styles.title}>
                <img className = {styles.instructionIcon} src = {instruction} alt = "instructions" />
                Instructions
            </h1>
            <div className = {styles.instructionBody}>
                <p><b>Mandatory: </b>Make sure that the video has <b>ENGLISH</b> transcript available.</p>
                <p>1. Open YouTube on smartphone or desktop browser.</p>
                <p>2. Click on the share button.</p>
                <img className = {styles.page} src = {page1} alt = "instructions" />
                <p>3. Copy the link.</p>
                <img className = {styles.page} src = {page2} alt = "instructions" />
                <p>4. Paste the link in above given input box.</p>
            </div>
        </div>
    )
}

export default YoutubeInstructions;